<script>
import { mapActions } from "vuex";
import ModalCambiarAvatar from "@/components/perfil/ModalCambiarAvatar.vue";
import { EventBus } from "@/eventBus";

export default {
  name: "MiPerfil",
  components: {
    ModalCambiarAvatar,
  },

  data() {
    return {
      show_spinner: false,
      correo_usuario: this.$ls.get("user").correo,
      movil_usuario: this.$ls.get("user").telefono_movil,
      anexo_usuario: this.$ls.get("user").anexo,
      telefono_usuario: this.$ls.get("user").telefono_fijo,
      gerencia_usuario: this.$ls.get("user").gerencia[0]
        ? this.$ls.get("user").gerencia[0].nombre_gerencia
        : "",
      cargo_usuario: this.$ls.get("user").cargo[0]
        ? this.$ls.get("user").cargo[0].nombre_cargo
        : "",
      userPasswordForm: {
        oldPassword: "",
        newPassword: "",
        newPasswordConfirm: "",
      },
      id_usuario: this.$ls.get("user").id_usuario,
      userData: [],
      nuevaImagenPerfil: "",
    };
  },
  created() {
    this.userData = this.$ls.get("user");
  },
  computed: {
    errorNewPassword() {
      const pwd = this.userPasswordForm.newPassword || "";
      let messageTitle = "Errores de validación: ";
      let message = [];

      pwd.length < 6 && message.push("debe tener al menos 6 caracteres");
      !/[A-Z]/.test(pwd) && message.push("debe tener al menos 1 mayúscula");
      !/[a-z]/.test(pwd) && message.push("debe tener al menos 1 minúscula");
      !/\d/.test(pwd) && message.push("debe tener al menos 1 dígito");
      !/[!@#$%^&*.]/.test(pwd) &&
        message.push("debe tener al menos 1 caracter especial");
      if (message.length === 0) return "";
      if (message.length === 1) return messageTitle + message[0];

      const ultimoMsg = message.pop();
      return messageTitle + message.join(", ") + " y " + ultimoMsg;
    },
  },
  methods: {
    ...mapActions("ProfileModule", [
      "editPasswordAction",
      "verifyPasswordAction",
      "editImage",
      "editProfile",
    ]),

    async onChangePasswordSubmit() {
      this.show_spinner = true;

      // validación de contraseña actual
      const check = await this.confirmCurrentPassword();
      if (check === false) {
        this.toastConfirmCurrentPasswordPasswordError();
        this.cleanPasswordForm();
        this.show_spinner = false;
        return;
      } else if (check === null) {
        this.toastGenericError();
        this.show_spinner = false;
        return;
      }
      const editPasswordRes = await this.editPassword();

      if (editPasswordRes) {
        // cambio exitoso
        this.toastEditPasswordSuccess();
        this.cleanPasswordForm();
        this.collapsePasswordForm();
      } 
      if (editPasswordRes === null) this.toastEditPasswordError();
      if (editPasswordRes === false) this.toastEditPasswordInvalid();
      EventBus.$emit("updateUser");
      this.show_spinner = false;
    },

    async confirmCurrentPassword() {
      const encodedPassword = btoa(this.userPasswordForm.oldPassword);
      const payload = {
        id_usuario: this.id_usuario,
        password: encodedPassword,
      };

      const res = await this.verifyPasswordAction(payload);
      const check = res === null ? res : res.password;
      return check;
    },

    async editPassword() {
      const encodedNewPassword = btoa(
        btoa(btoa(this.userPasswordForm.newPassword))
      );
      const payload = {
        id_usuario: this.id_usuario,
        password: encodedNewPassword,
      };
      const res = await this.editPasswordAction(payload);
      const check = res === null ? res : res.password;
      return check;
    },

    cleanPasswordForm() {
      this.userPasswordForm = {};
      this.$nextTick(() => {
        this.$formulate.reset('passwordChangeForm')
      });
    },

    collapsePasswordForm() {
      this.$refs.btnCambiarPassword.click();
    },

    toastConfirmCurrentPasswordPasswordError() {
      this.$toast.open({
        message: "La contraseña actual ingresada es incorrecta.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
    toastEditPasswordSuccess() {
      this.$toast.open({
        message: "Cambio de contraseña exitoso.",
        duration: 5000,
        position: "top-right",
      });
    },
    toastEditPasswordError() {
      this.$toast.open({
        message:
          "Error al cambiar la contraseña. Por favor intenta nuevamente.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
    toastEditPasswordInvalid() {
      this.$toast.open({
        message:
          "La contraseña debe contener al menos 6 caracteres, minúscula, mayúscula, un dígito y un caracter especial.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },

    //FF
    guardarPerfil() {
      if (this.nuevaImagenPerfil !== "") {
        this.editImage({
          idUsuario: this.$ls.get("user").id_usuario,
          idEmpresaFk: this.$ls.get("user").id_empresa_fk,
          imagenPerfil: this.nuevaImagenPerfil.split(",")[1],
          formato: "image/jpeg",
        }).then(() => {
          this.$refs.modalCambiarAvatar.cleanData();
          this.nuevaImagenPerfil = "";
          EventBus.$emit("updateUser");
          this.userData = this.$ls.get("user");
        });
      }
      if (
        this.correo_usuario !== this.$ls.get("user").correo ||
        this.movil_usuario !== this.$ls.get("user").telefono_movil ||
        this.anexo_usuario !== this.$ls.get("user").anexo ||
        this.telefono_usuario !== this.$ls.get("user").telefono_fijo
      ) {
        this.editProfile({
          idUsuario: this.$ls.get("user").id_usuario,
          correo: this.correo_usuario,
          telefonoMovil: this.movil_usuario,
          anexo: this.anexo_usuario,
          telefonoFijo: this.telefono_usuario,
        });
        EventBus.$emit("updateUser");
        this.userData = this.$ls.get("user");
      }
    },
    capturarImagenAvatar(img) {
      this.nuevaImagenPerfil = img;
      this.$nextTick(() => {
        this.$refs.modalCambiarAvatar.cleanData();
      });
    },
  },
};
</script>

<template>
  <section id="perfil">
    <div class="row">
      <div class="col-12 mb-0">
        <h1
          class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center"
        >
          <font-awesome-icon
            icon="fa-solid fa-circle-user"
            class="me-2 icon-svg-45"
          ></font-awesome-icon>
          Mi Perfil
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home" class="color-main">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">Mi Perfil</li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">Edita tus datos.</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="card border-0 card-shadow">
          <div class="card-body d-flex flex-column align-items-center">
            <img
              v-if="nuevaImagenPerfil !== ''"
              width="220"
              height="220"
              class="img-object-cover rounded-circle border border-2 border-main p-2"
              :src="nuevaImagenPerfil"
            />
            <img
              v-else-if="userData.imagen_perfil"
              width="220"
              height="220"
              class="img-object-cover rounded-circle border border-2 border-main p-2"
              :src="userData.imagen_perfil"
            />
            <img
              v-else-if="!userData.imagen_perfil"
              width="220"
              height="220"
              class="img-object-cover rounded-circle border border-2 border-main p-2"
              src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
            />
            <h3 class="color-main mt-2 font-700">
              {{ userData.primer_nombre }} {{ userData.apellido_paterno }}
            </h3>
            <h5 class="text-secondary text-opacity-75 font-700">
              {{ userData.rut_usuario }}-{{ userData.dv_usuario }}
            </h5>
            <div class="d-flex gap-2">
              <a
                href="javascript:"
                data-bs-toggle="modal"
                data-bs-target="#modal-cambiar-avatar"
                class="btn btn-custom btn-custom-main rounded-4 mw-150"
              >
                {{
                  nuevaImagenPerfil !== ""
                    ? "Cargar otra imagen"
                    : "Cambiar imagen"
                }}
              </a>
              <a
                href="javascript:"
                class="btn btn-custom btn-custom-red rounded-4 mw-150"
                v-show="nuevaImagenPerfil !== ''"
                @click="nuevaImagenPerfil = ''"
              >
                Eliminar imagen
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-8">
        <div class="card border-0">
          <div class="card-body">
            <form @submit.prevent="guardarPerfil()">
              <div class="row">
                <div class="col-12">
                  <h5 class="text-secondary font-700 border-bottom pb-2 mb-3">
                    Información de la cuenta
                  </h5>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6 mb-3">
                  <label class="form-label text-secondary"> Cargo </label>
                  <input
                    v-model="cargo_usuario"
                    type="text"
                    disabled
                    autocomplete="off"
                    class="form-control input-custom"
                  />
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label class="form-label text-secondary"> Gerencia </label>
                  <input
                    v-model="gerencia_usuario"
                    type="text"
                    disabled
                    autocomplete="off"
                    class="form-control input-custom"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6 mb-3">
                  <label class="form-label text-secondary"> Teléfono </label>
                  <input
                    v-model="telefono_usuario"
                    type="text"
                    autocomplete="off"
                    class="form-control input-custom"
                    placeholder="+56 2 2345 6789"
                  />
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label class="form-label text-secondary"> Anexo </label>
                  <input
                    v-model="anexo_usuario"
                    type="text"
                    autocomplete="off"
                    class="form-control input-custom"
                    placeholder="111111"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6 mb-3">
                  <label class="form-label text-secondary"> Móvil </label>
                  <input
                    v-model="movil_usuario"
                    type="text"
                    autocomplete="off"
                    class="form-control input-custom"
                    placeholder="+569 2345 6789"
                  />
                </div>
                <div class="col-12 col-lg-6 mb-3">
                  <label class="form-label text-secondary"> Correo </label>
                  <input
                    v-model="correo_usuario"
                    type="text"
                    autocomplete="off"
                    class="form-control input-custom"
                    placeholder="Ingresa tu correo"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12 d-flex justify-content-end">
                  <a
                    class="btn btn-custom btn-custom-yellow rounded-4 mw-150"
                    ref="btnCambiarPassword"
                    data-bs-toggle="collapse"
                    href="#collapsePassword"
                  >
                    Cambiar contraseña
                  </a>
                  <button
                    type="submit"
                    class="btn btn-custom btn-custom-main rounded-4 mw-150 ms-2"
                  >
                    Guardar cambios
                  </button>
                </div>
              </div>
            </form>

            <div class="collapse" id="collapsePassword">
              <div class="card card-body">
                <div class="row">
                  <div class="col-12">
                    <h5 class="text-secondary font-700 border-bottom pb-2 mb-3">
                      Cambiar contraseña
                    </h5>
                  </div>
                </div>

                <FormulateForm
                  ref="passwordForm"
                  v-model="userPasswordForm"
                  name="passwordChangeForm"
                  @submit="onChangePasswordSubmit"
                >
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label text-secondary">
                        Ingresa tu contraseña actual
                      </label>
                      <FormulateInput
                        type="password"
                        name="oldPassword"
                        validation="required"
                        placeholder="********"
                        input-class="form-control input-custom"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label text-secondary">
                        Ingresa tu nueva contraseña
                      </label>
                      <small
                        class="text-muted font-weight-bold"
                        style="font-size: 12px"
                      >
                        (De al menos 6 caracteres, una minúscula, una mayúscula,
                        un número y un carácter especial)
                      </small>
                      <FormulateInput
                        type="password"
                        name="newPassword"
                        placeholder="********"
                        :validation="['required', 'passwordStrength']"
                        :validation-rules="{
                          passwordStrength: ({ value }) => {
                            const hasUpperCase = /[A-Z]/.test(value);
                            const hasLowerCase = /[a-z]/.test(value);
                            const hasNumber = /\d/.test(value);
                            const hasSpecialChar = /[!@#$%^&*\.]/.test(value);
                            return (
                              value.length >= 6 &&
                              hasUpperCase &&
                              hasLowerCase &&
                              hasNumber &&
                              hasSpecialChar
                            );
                          },
                        }"
                        :validation-messages="{
                          required: 'La contraseña es obligatoria.',
                          passwordStrength: errorNewPassword,
                        }"
                        input-class="form-control input-custom"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label text-secondary">
                        Confirma nueva contraseña
                      </label>
                      <FormulateInput
                        type="password"
                        name="newPasswordConfirm"
                        placeholder="********"
                        validation="bail|required|confirm:newPassword"
                        input-class="form-control input-custom"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                      <button
                        class="btn btn-custom btn-custom-line-main rounded-4 mw-150"
                        data-bs-toggle="collapse"
                        href="#collapsePassword"
                      >
                        Cancelar
                      </button>
                      <FormulateInput
                        type="submit"
                        label="Guardar cambios"
                        input-class="btn btn-custom btn-custom-main rounded-4 mw-150 ms-2"
                      />
                    </div>
                  </div>
                </FormulateForm>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalCambiarAvatar
      ref="modalCambiarAvatar"
      @actualizarImagenPerfil="capturarImagenAvatar"
    />
  </section>
</template>
